/**
 * Resolve a media URL that may be relative (uploaded, e.g. /api/files/...) or absolute (external).
 * Returns a browser-loadable absolute URL.
 */
export function mediaUrl(u) {
    if (!u) return "";
    if (u.startsWith("http://") || u.startsWith("https://") || u.startsWith("data:")) return u;
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base}${u.startsWith("/") ? "" : "/"}${u}`;
}
